import React, { Fragment, useEffect, useState } from 'react';
import { map, filter, isEmpty } from 'lodash';
import GenericButton from '../common/GenericButton';
import GenericSearch from '../common/GenericSearch';
import ListItems from './components/ListItems';

const DualList = ({
  updateSelectedItems,
  options,
  selectedList,
  searchLabel,
  selectedListLabel,
  availableListLabel,
  searchPlaceHolder,
  optionName,
}) => {
  const [selected, setSelected] = useState(true);
  const [items, setItems] = useState(options);
  const [itemsLeft, setItemsLeft] = useState([]);
  const [selectedItemsLeft, setSelectedItemsLeft] = useState([]);
  const [itemsRight, setItemsRight] = useState([]);
  const [selectedItemsRight, setSelectedItemsRight] = useState([]);
  const [rightSelectionCount, setRightSelectionCount] = useState(0);
  useEffect(() => {
    setItemsLeft(items);
  }, []);
  useEffect(() => {
    if (optionName === 'MEMRI-USERS') {
      if (selectedList.length && options.length) {
        setItemsLeft(
          options.filter(code =>
            selectedList.every(sel => sel.memriUserId !== code.memriUserId)
          )
        );
        setItemsRight(
          options.filter(code =>
            selectedList.find(sel => sel.memriUserId === code.memriUserId)
          )
        );
      }
    } else {
      if (selectedList.length && options.length) {
        setItemsLeft(
          options.filter(code => selectedList.every(sel => sel.id !== code.id))
        );
        setItemsRight(
          options.filter(code => selectedList.find(sel => sel.id === code.id))
        );
      }
    }
  }, [selectedList, options]);
  useEffect(() => {
    updateSelectedItems(itemsRight);
  }, [itemsRight]);
  const addSelected = () => {
    const selections = [];
    const itemsRemaining = [];
    itemsLeft.map(item => {
      if (item.selected) {
        selections.push(item);
      } else {
        itemsRemaining.push(item);
      }
      return item;
    });

    itemsRight.map(item => {
      selections.push(item);
      return item;
    });

    setItemsLeft(itemsRemaining);
    setItemsRight(selections);
    setRightSelectionCount(selections.length);
    setSelectedItemsRight([]);
    setSelectedItemsLeft([]);
  };
  const removeSelected = () => {
    const selections = [];
    const itemsRemaining = [];
    itemsRight.map(item => {
      if (item.selected) {
        selections.push(item);
      } else {
        itemsRemaining.push(item);
      }
      return item;
    });

    itemsLeft.map(item => {
      selections.push(item);
      return item;
    });
    setItemsLeft(selections);
    setItemsRight(itemsRemaining);
    setRightSelectionCount(itemsRemaining.length);
    setSelectedItemsRight([]), setSelectedItemsLeft([]);
  };

  const removeAll = () => {
    const leftPanelItems = [];
    leftPanelItems.push(...itemsLeft, ...itemsRight);
    setItemsRight([]);
    setItemsLeft(leftPanelItems);
    setRightSelectionCount(0);
    setSelectedItemsRight([]);
    setSelectedItemsLeft([]);
  };

  const handleRightPanelClick = (id, clearExisting, shiftKey) => {
    let selectedItems = [];
    if (!shiftKey) {
      if (!clearExisting) {
        selectedItems = selectedItemsRight;
      }
      selectedItems.push(parseInt(id, 10));
      setSelectedItemsRight([...selectedItems]);
    } else {
      selectedItems = selectedItemsRight;
      let lastItem = selectedItemsRight.pop();
      let currentItemId = id;
      if (lastItem > currentItemId) {
        const temp = lastItem;
        lastItem = currentItemId;
        currentItemId = temp;
      }
      itemsRight.map(item => {
        if (item.id >= lastItem && item.id <= parseInt(currentItemId, 10)) {
          selectedItems.push(item.id);
        }
        return item;
      });
      setSelectedItemsRight([...selectedItems]);
    }
  };

  const renderSearchItems = () => {
    const filteredItems = [];
    map(items, item => {
      const hasItem = filter(itemsRight, k => k.id === item.id);
      if (isEmpty(hasItem)) {
        filteredItems.push(item);
      }
    });
    return filteredItems;
  };
  const handleSearch = searchResult => setItemsLeft(searchResult);
  const handleLeftPanelClick = (id, clearExisting, shiftKey) => {
    let selectedItems = [];
    if (!shiftKey) {
      if (!clearExisting) {
        selectedItems = selectedItemsLeft;
      }
      selectedItems.push(parseInt(id, 10));
      setSelectedItemsLeft([...selectedItems]);
    } else {
      selectedItems = selectedItemsLeft;
      let lastItem = selectedItemsLeft.pop();
      let currentItemId = id;
      if (lastItem > currentItemId) {
        const temp = lastItem;
        lastItem = currentItemId;
        currentItemId = temp;
      }
      itemsLeft.map(item => {
        if (item.id >= lastItem && item.id <= parseInt(currentItemId, 10)) {
          selectedItems.push(item.id);
        }
        return item;
      });
      setSelectedItemsLeft([...selectedItems]);
    }
  };
  const handleMoveAllRight = () => {
    const allItemsToRight = itemsLeft;
    map(itemsRight, item => {
      allItemsToRight.push(item);
    });
    setItemsRight(allItemsToRight);
    setItemsLeft([]);
    setSelectedItemsLeft([]);
    setSelectedItemsRight([]);
  };

  const handleMoveAllLeft = () => {
    const allItemsToLeft = itemsRight;
    map(itemsLeft, item => {
      allItemsToLeft.push(item);
    });
    setItemsLeft(allItemsToLeft);
    setItemsRight([]);
    setRightSelectionCount(0);
    setSelectedItemsRight([]);
    setSelectedItemsLeft([]);
  };
  if (optionName === 'MEMRI-USERS') {
    return (
      <Fragment>
        <div className="add-user-form">
          <div className="add-user-form--row">
            <div className="add-user-form--col">
              <span className="market-label">{availableListLabel}</span>
              <ListItems
                items={itemsLeft}
                selectedItems={selectedItemsLeft}
                handleSelection={handleLeftPanelClick}
              />
            </div>
            <div className="add-user-form--col-center add-user-form--col">
              <div className="stacked button-group multi-select-button-group">
                <GenericButton
                  name=" "
                  btnStyle="button btn-add btn-priaryDisable"
                  onBtnClick={addSelected}
                  {...(selectedItemsLeft.length < 1
                    ? { btnDisabled: true }
                    : {})}
                />

                <GenericButton
                  name=" "
                  btnStyle="button btn-add-all btn-priaryDisable"
                  onBtnClick={handleMoveAllRight}
                  {...(options.length < 1 ? { btnDisabled: true } : {})}
                />
                <GenericButton
                  name=" "
                  btnStyle="button btn-remove btn-cncl"
                  onBtnClick={removeSelected}
                  {...(selectedItemsRight.length < 1
                    ? { btnDisabled: true }
                    : {})}
                />
                <GenericButton
                  name=" "
                  btnStyle="button btn-remove-all btn-priaryDisable"
                  onBtnClick={handleMoveAllLeft}
                  {...(itemsRight.length < 1 ? { btnDisabled: true } : {})}
                />
              </div>
            </div>
            <div className="add-user-form--col">
              <span className="market-label">{selectedListLabel}</span>
              <ListItems
                items={itemsRight}
                selectedItems={selectedItemsRight}
                handleSelection={handleRightPanelClick}
                isSelectedBox
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
  return (
    <Fragment>
      <div className="add-user-form">
        <div className="trend-search-component">
          <div className="add-user-form--row">
            <div className="add-user-form--col">
              <span className="market-label">{searchLabel}</span>
              <GenericSearch
                searchItems={renderSearchItems()}
                searchField="dmaDesc"
                handleSearchResult={handleSearch}
                placeholder={searchPlaceHolder}
                optionName={optionName}
                propCodeDescription="propCodeDescription"
                propCode="propCode"
              />
            </div>
          </div>
        </div>
        <div className="add-user-form--row">
          <div className="add-user-form--col">
            <span className="market-label">{availableListLabel}</span>
            <ListItems
              items={itemsLeft}
              selectedItems={selectedItemsLeft}
              handleSelection={handleLeftPanelClick}
            />
          </div>
          <div className="add-user-form--col-center add-user-form--col">
            <div className="stacked button-group multi-select-button-group">
              <GenericButton
                name=" "
                btnStyle="button btn-add btn-priaryDisable"
                onBtnClick={addSelected}
                {...(selectedItemsLeft.length < 1 ? { btnDisabled: true } : {})}
              />

              <GenericButton
                name=" "
                btnStyle="button btn-add-all btn-priaryDisable"
                onBtnClick={handleMoveAllRight}
                {...(itemsLeft.length < 1 ? { btnDisabled: true } : {})}
                // {...(itemsLeft.length
                //   ? itemsLeft.length
                //   : '' < 1
                //   ? { btnDisabled: true }
                //   : {})}
              />
              <GenericButton
                name=" "
                btnStyle="button btn-remove btn-cncl"
                onBtnClick={removeSelected}
                {...(selectedItemsRight.length < 1
                  ? { btnDisabled: true }
                  : {})}
              />
              <GenericButton
                name=" "
                btnStyle="button btn-remove-all btn-priaryDisable"
                onBtnClick={handleMoveAllLeft}
                {...(itemsRight.length < 1 ? { btnDisabled: true } : {})}
              />
            </div>
          </div>
          <div className="add-user-form--col">
            <span className="market-label">{selectedListLabel}</span>
            <ListItems
              items={itemsRight}
              selectedItems={selectedItemsRight}
              handleSelection={handleRightPanelClick}
              isSelectedBox
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default DualList;
